<template lang="pug">
  .input-campo-temporal(:class="containerClass" :style="containerStyle")
    PontotelInput.input-campo-temporal__hora(
      v-bind="localAttributes"
      tipo="text",
      :label="label"
      v-model="textInputComputed",
      :largura="largura"
      mascara="##:##"
      placeholder="00:00",
      :desabilitado="disabled || loading",
      v-on="localListeners",
      @focus="($event) => $event.target.select()"
      :erro="error"
      :infoInferior="infoInferior || null"
      :obrigatorio="required"
    )

    PCheckbox(label="+1d", v-if="showPlusOneDay" v-model="plusOneDay", :disabled="disabled")

</template>

<script>
import { PontotelInput } from '@Lar21/imaginii-web-components/lib/vue'
import moment from 'moment'

import PCheckbox from './PCheckbox.vue'
import { handlerUseStateVmodel } from '../mixins/handlerUseStateVmodel'
import {
  extrairAtributosDeControle,
  extrairClasseDoContainer,
  extrairEstiloDoContainer,
  extrairListenersDosAttrs
} from '../mixins/localListenersAndAttributes'
import {
  formatString24Hours
} from 'src/utils'
import { verificarSeHorarioInputValido } from 'src/utils/validadoras/validadoras'
import { converterHorarioParaObjetoMoment } from 'src/utils/formatadoras/formatadoras'

export default {
  name: 'InputCampoTemporal',
  inheritAttrs: false,
  emits: ['update:modelValue', 'change'],
  props: {
    label: {type: String, required: true},
    baseDate: {type: Date, required: true},
    showPlusOneDay: {type: Boolean, default: false},
    loading: Boolean,
    disabled: Boolean,
    error: {type: String, default: ''},
    infoInferior: { type: String, default: '' },
    format24Hours: { type: Boolean, default: false },
    required: { type: Boolean, required: false, default: false },
    largura: { type: String, required: false, default: '100px' }
  },
  data () {
    return {
      textInput: '',
      internalPlusOneDay: false
    }
  },
  created () {
    if (moment(this.state).date() > moment(this.baseDate).date()) {
      this.internalPlusOneDay = true
    }

    this.textInput = moment(this.state).format('HH:mm')
  },
  computed: {
    plusOneDay: {
      set (newValue) {
        const baseDayOfMonth = moment(this.baseDate).date()
        const stateDayOfMonth = moment(this.state).date()

        if (newValue && (!this.state || !stateDayOfMonth)) {
          return;
        }

        this.internalPlusOneDay = newValue

        if (newValue) {
          this.state = baseDayOfMonth === stateDayOfMonth
            ? moment(this.state).add(1, 'days').toDate()
            : moment(this.state).toDate()
        } else {
          if (!this.state) return;
          this.state = baseDayOfMonth === stateDayOfMonth
            ? moment(this.state).toDate()
            : moment(this.state).subtract(1, 'days').toDate()
        }
      },
      get () {
        return this.internalPlusOneDay
      }
    },
    textInputComputed: {
      get () {
        return this.textInput
      },
      set (val) {
        this.textInput = val
        if (this.valid) {
          const time = converterHorarioParaObjetoMoment(val)
          const mergedDates = moment(this.baseDate).set({hour: time.hours(), minute: time.minutes(), seconds: 0})
          this.state = (this.plusOneDay ? mergedDates.add(1, 'days') : mergedDates).toDate()
        } else {
          if (this.textInput.length < 5) this.state = null
          if (this.format24Hours && this.textInput.length === 5) {
            this.textInput = formatString24Hours(this.textInput)
          }
        }
      }
    },
    valid () {
      return verificarSeHorarioInputValido(this.textInput, true)
    },
    containerClass () {
      return extrairClasseDoContainer(this.$attrs)
    },
    containerStyle () {
      return extrairEstiloDoContainer(this.$attrs)
    },
    localListeners () {
      return extrairListenersDosAttrs(this.$attrs)
    },
    localAttributes () {
      return extrairAtributosDeControle(this.$attrs, ['disabled'])
    }
  },
  watch: {
    baseDate: function (newValue, oldValue) {
      if (moment(newValue).diff(oldValue, 'hours') < 1) return
      if (this.valid) {
        const time = converterHorarioParaObjetoMoment(this.textInput)
        const mergedDates = moment(newValue).set({hour: time.hours(), minute: time.minutes()})
        this.state = (this.plusOneDay ? mergedDates.add(1, 'days') : mergedDates).toDate()
      }
    },
    state: function () {
      this.internalPlusOneDay = moment(this.state).date() > moment(this.baseDate).date()
      if (this.state) {
        this.textInput = moment(this.state).format('HH:mm')
      } else {
        this.textInput = ''
      }
    }
  },
  mixins: [handlerUseStateVmodel()],
  components: { PontotelInput, PCheckbox }
}
</script>

<style scoped>
.input-campo-temporal {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
